<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <div class="row">
  <ol class="breadcrumb" style="padding: 10px 20px 0px;">
    <li><a href="#" >Home</a></li>
    <li class="active">{{'calculator.pensioncalculatorsetup.heading' | translate}}</li>
  </ol>
  <div class="col-md-12 outer-cover-faq">
    <div class="col-md-12" *ngIf="serverError">
      <div class="alert alert-danger">
        {{'internalServerError' | translate}}
      </div>
    </div>
    <div class="col-md-12 noBottommargin">
  <div class="col-md-12">
    <h2>{{'calculator.pensioncalculatorsetup.heading' | translate}}</h2>
  </div>
      <div class="col-md-12 noBottommargin">
        <div class="alert alert-success alert-dismissable" *ngIf="success">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong>{{'calculator.pensioncalculatorsetup.resultmessage' | translate}}</strong>
        </div>
        <div class="alert alert-danger alert-dismissable" *ngIf="error">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong>Calculator setup values could not update</strong>
        </div>
        <div class="alert alert-danger alert-dismissable" *ngIf="formerror">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong> {{'calculator.pensionCalculator.serverError' | translate}}</strong>
        </div>
      </div>
      <div class="col-md-12 noBottommargin" *ngIf="progress">
        <img class="loader" src="assets/images/loading.gif"/>
      </div>
    <div class="col-md-12 noBottommargin" *ngIf="showForm">
     <form class="form-horizontal" [formGroup]="pensionCalcultorForm" novalidate (submit)="updateSetupValues()">
       <div class="form-group row">
         <label for="period-until-retirement" class="col-md-5 col-form-label noBottommargin" >{{'calculator.pensionCalculator.pa' | translate}}<span class="mandatorySymbol">&nbsp;*</span></label>
         <div class="col-md-6 noBottommargin">

           <input class="form-control rightAlign" type="text" id="period-until-retirement"
                  (keyup)="handlePensionAgeError($event)" [textMask]="{mask: yearMask}"
                  formControlName="retirementAge" tooltip="{{'calculator.pensionCalculator.patip' | translate}}">
         </div>
         <div class="col-md-5"  *ngIf="ageError"></div>
         <div class="col-md-6 noBottommargin" *ngIf="ageError">
           <div class="alert alert-info noBottommargin">
             Please choose a valid pension age
           </div>
         </div>
       </div>
       <div class="form-group row" >
         <label for="desired-retirement-planned" class="col-md-5 col-form-label noBottommargin">{{'calculator.pensionCalculator.la' | translate}}<span class="mandatorySymbol">&nbsp;*</span></label>
         <div class="col-md-6 noBottommargin">

           <input class="form-control rightAlign" type="text" id="desired-retirement-planned"
                  (keyup)="handleLifeExpectedError($event)" [textMask]="{mask: yearMask}"
                  formControlName="lifeExpected" tooltip="{{'calculator.pensionCalculator.latip' | translate}}">

         </div>
         <div class="col-md-5" *ngIf="lifeExpectedError"></div>
         <div class="col-md-6 noBottommargin" *ngIf="lifeExpectedError">
           <div class="alert alert-info noBottommargin">
             {{'calculator.pensionCalculator.lifeexpectedError' | translate}}
           </div>
         </div>
       </div>
     <div class="form-group row" >

      <label for="cost-of-living" class="col-md-5 col-form-label noBottommargin">{{'calculator.pensionCalculator.ira' | translate}}<span class="mandatorySymbol">&nbsp;*</span></label>
      <div class="col-md-6 noBottommargin">

        <input class="form-control rightAlign" type="text" id="cost-of-living"
               (keyup)="handleInflationRate($event)"
               [textMask]="{mask: numberMask}"
               formControlName="inflationRate" tooltip="{{'calculator.pensionCalculator.iratip' | translate}}">

      </div>
       <div class="col-md-5"  *ngIf="inflationError"></div>
       <div class="col-md-6 noBottommargin" *ngIf="inflationError">
         <div class="alert alert-info noBottommargin">
           {{'calculator.pensionCalculator.inflationError' | translate}}
         </div>
       </div>
      </div>
    <div class="form-group row" >
      <label for="assumption-annual-development-results" class="col-md-5 col-form-label noBottommargin">{{'calculator.pensionCalculator.aadr' | translate}}<span class="mandatorySymbol">&nbsp;*</span></label>
      <div class="col-md-6 noBottommargin">

        <input class="form-control rightAlign" type="text" id="assumption-annual-development-results"
               (keyup)="handlePercentage($event,1)"
               [textMask]="{mask: numberMask}"
               formControlName="annualDevResults" tooltip="{{'calculator.pensionCalculator.aadrtip' | translate}}">

      </div>
    </div>
    <div class="form-group row">
      <label for="total-asset" class="col-md-5 col-form-label noBottommargin">{{'calculator.pensionCalculator.aasi' | translate}}<span class="mandatorySymbol">&nbsp;*</span></label>
      <div class="col-md-6 noBottommargin">

        <input class="form-control rightAlign" type="text" id="total-asset"
               (keyup)="handlePercentage($event,2)"
               [textMask]="{mask: numberMask}"
               formControlName="avgSalaryIncYear" tooltip="{{'calculator.pensionCalculator.aasitip' | translate}}">

      </div>
    </div>
      <div class="form-group row noBottommargin">
        <div class="col-md-5 noBottommargin"></div>
        <div class="col-md-6 noBottommargin">
          <button type="submit" class="btn btn-primary"  [disabled]="!pensionCalcultorForm.valid||inflationError||lifeExpectedError">{{'calculator.pensioncalculatorsetup.upbtn' | translate}}</button>
        </div>
      </div>
      </form>
    </div>
      </div>
  </div>
</div>
</div>
</div>
